import DOMPurify from "dompurify";

class StringToHtml extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  static get observedAttributes() {
    return ["content"];
  }

  attributeChangedCallback(name, _oldValue, newValue) {
    if (name === "content") {
      this.render(newValue);
    }
  }

  render(content) {
    const sanitizedContent = DOMPurify.sanitize(content);
    this.shadowRoot.innerHTML = sanitizedContent;
  }
}

const init = () => {
  if (!customElements.get("string-to-html")) {
    customElements.define("string-to-html", StringToHtml);
  }
};

export default { init };
